import { Pipe, PipeTransform } from '@angular/core';
import * as _ from "lodash";

@Pipe({
  name: 'property',
  standalone: true
})
export class PropertyPipe implements PipeTransform {

  transform(value: object, property: string): any {
    return _.get(value, property);
  }

}
